import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { CircleOutlined } from "@mui/icons-material";
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import FormButtons from "../../common/register/FormButtons";
import { passwordConditions } from "../../constants/constants";
import InputField from "../../common/InputField";
import { toast, Toaster } from "react-hot-toast";
import { BASE_URL } from "../../constants/ApiUrls";
import { uUrls } from "../../constants/ApiUrls";
import { useTranslation } from "react-i18next";

const Password = (props) => {
  const { t } = useTranslation();
  const { back, authToken } = props;
  const validate = Yup.object({
    password: Yup.string()
      .matches(
        // eslint-disable-next-line
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        t("pswd-validation")
      )
      .required(t("required")),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], t("pswd-must-match"))
      .matches(
        // eslint-disable-next-line
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        t("pswd-validation")
      )
      .required(t("required")),
  });

  const handleSubmit = async (formik) => {
    try {
      const { data } = await axios.put(
        BASE_URL + uUrls.CREATE_PASSWORD,
        formik,
        {
          headers: {
            Authorization: `Bearer  ${authToken}`,
          },
        }
      );
      // toast.success(data?.message);
      window.location = "/";
    } catch (error) {
      toast.error(error.response?.data?.message);
    }
  };

  return (
    <>
      <Toaster />
      <Formik
        initialValues={{
          password: "",
          confirmPassword: "",
        }}
        validationSchema={validate}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <Typography
              variant="h4"
              fontWeight="bold"
              color="color.magentaDark1"
            >
              {t("password")}
            </Typography>
            <Box component="div" marginTop="3rem">
              <InputField
                name="password"
                type="password"
                label={t("password")}
                maxLength={35}
              />
              <InputField
                name="confirmPassword"
                type="password"
                label={t("repeat-password")}
                maxLength={35}
              />
            </Box>
            <Typography
              color="color.megentaDark"
              marginTop="3rem"
              fontSize="0.7rem"
            >
              {t("properties-of-password")}
            </Typography>
            <List className="password-rules">
              {passwordConditions?.map((item) => (
                <ListItem disablePadding key={item.id}>
                  <ListItemIcon
                    sx={{
                      minWidth: "auto",
                      fontSize: "10px !important",
                    }}
                  >
                    <CircleOutlined fontSize="0.5rem" />
                  </ListItemIcon>
                  <ListItemText
                    primary={item.name}
                    sx={{
                      fontSize: "10px !important",
                      margin: "0 0 0 0.5rem",
                    }}
                  />
                </ListItem>
              ))}
            </List>

            <FormButtons back={back} />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Password;
